import { cn } from '@/lib/utils'
import { Badge } from '@/components/ui/badge'
import type { LeadStatus } from '@limo/shared'
import { LEAD_STATUS_LABELS, LEAD_STATUS_COLORS } from '@limo/shared'

interface LeadStatusBadgeProps {
  status: LeadStatus
  className?: string
}

export function LeadStatusBadge({ status, className }: LeadStatusBadgeProps) {
  const label = LEAD_STATUS_LABELS[status] || status
  const colors = LEAD_STATUS_COLORS[status] || LEAD_STATUS_COLORS.open

  return (
    <Badge
      variant="outline"
      className={cn(
        'font-medium border',
        colors.bg,
        colors.text,
        colors.border,
        className
      )}
    >
      {label}
    </Badge>
  )
}
